export default __webpack_public_path__ + "static/media/device-total.ccda97a0.svg";